import { render } from "./VabeneClosureCalendar.vue?vue&type=template&id=5318b0a3&scoped=true&ts=true"
import script from "./VabeneClosureCalendar.vue?vue&type=script&lang=ts"
export * from "./VabeneClosureCalendar.vue?vue&type=script&lang=ts"

import "./VabeneClosureCalendar.vue?vue&type=style&index=0&id=5318b0a3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5318b0a3"]])

export default __exports__